<div class="fab-container hidden-xs">
  <div
    class="fab fab-icon-holder bg-primary"
    role="button"
    (click)="toggleFab()"
  >
    <i class="bx bxs-message-dots fs-30"></i>
  </div>
  <ul class="fab-options" [class]="cssClass">
    <li>
      <span class="fab-label text-dark fw-normal">Whatsapp</span>
      <a href="https://wa.me/2348093962004?&text=Hi%20Kreador,%20My%20name%20is%20%27Please%20insert%20your%20fullname%20here%27%20and%20I%20will%20like%20to%20Speak%20with%20an%20Expert%20Consultant." target="_blank" class="fab-icon-holder bg-white">
        <i class="bx bxl-whatsapp text-primary"></i>
      </a>
    </li>
    <li>
      <span class="fab-label text-dark fw-normal">Request a callback</span>
      <a target="_blank" class="fab-icon-holder bg-white">
        <i class="bx bxs-phone-call text-primary"></i>
      </a>
    </li>
    <li>
      <span class="fab-label text-dark fw-normal">Live Chat</span>
      <a href="https://backoffice.kreador.io/im_livechat/support/1" target="_blank" class="fab-icon-holder bg-white"></a>
      <!-- <a href="https://tawk.to/chat/64b6a10c94cf5d49dc645c4b/1h5kma7jf" target="_blank" class="fab-icon-holder bg-white">
        <i class="bx bxs-chat text-primary"></i>
      </a> -->
    </li>
    <li>
      <span class="fab-label text-dark fw-normal">Send us a mail</span>
      <a target="_blank" class="fab-icon-holder bg-white">
        <i class="bx bxs-envelope text-primary"></i>
      </a>
    </li>
  </ul>
</div>


          